export default __webpack_public_path__ + "static/media/small-logo.2230cd33.svg";